import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
import { pageTitle } from '../../helpers/PageTitle';
import servicesData from '../../data/services';

const featureListData = [
  {
    title: 'Experienced General Practitioner',
    subTitle:
      'Years of clinical experience caring for patients <br />of every age across a broad range of <br />everyday medical needs.',
    iconUrl: 'images/icons/professional.svg',
  },
  {
    title: 'Comprehensive <br />Primary Care',
    subTitle:
      'From routine consultations to chronic disease <br />management, you receive complete primary <br />healthcare under one roof.',
    iconUrl: 'images/icons/comprehensive.svg',
  },
  {
    title: 'Patient-centered <br />Approach',
    subTitle:
      'Each consultation is an unhurried conversation, <br />tailored to your unique health history, <br />concerns, and goals.',
    iconUrl: 'images/icons/patient.svg',
  },
  {
    title: 'Well-equipped <br />Consulting Rooms',
    subTitle:
      'Our rooms are equipped for thorough <br />examinations, vaccinations, and <br />minor in-office procedures.',
    iconUrl: 'images/icons/facilities.svg',
  },
];

const funFactData = [
  { number: '20+', title: 'Years of medical practice' },
  { number: 'GP', title: 'Family medicine focus' },
  { number: 'All', title: 'Ages welcome' },
  { number: '6', title: 'Days open per week' },
];

export default function About() {
  pageTitle('Dr. L.D. Ramiah | About');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Welcome to <br />Dr. L.D. Ramiah's Practice"
        subTitle="Family medicine in Wyebank, Durban"
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle="What We Offer"
          sectionTitleUp="SERVICES"
          data={servicesData}
        />
      </Section>
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle="Why Choose Us"
          imgUrl="images/about/why_choose_us.jpeg"
          data={featureListData}
        />
      </Section>
      <Section>
        <FunFactSection
          bgUrl="images/about/fun_fact_bg.jpeg"
          data={funFactData}
        />
      </Section>
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
        className="cs_footer_margin_0"
      >
        <BannerSectionStyle4
          bgUrl="images/about/banner_bg_2.jpeg"
          title="Have a question? <br />Get in touch."
          subTitle="Reach out to the practice and we'll get back to you as soon as we can."
          center
        />
      </Section>
    </>
  );
}
